import { getStatePure, modifyState } from '~src/state';
import {
  addPagesToSidebar,
  createEmptyPage,
  goToLastPage,
} from '~src/multipages';
import { triggerStateChangedRequest } from '~core';

export const addPage = async (copyCurrentPage = true) => {
  const pages = getStatePure('pages');
  const newPage = createEmptyPage(copyCurrentPage);

  pages.push(newPage);
  await modifyState('pages', pages);
  await addPagesToSidebar();

  // Trigger unsaved state after adding a page
  triggerStateChangedRequest();

  return goToLastPage();
};
